import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { GetPopularClasses } from '../../../service/service';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import DataItem from '../../../ReuseableComponents/DataItem';

function Popular() {
    const userData = useSelector((state) => state.userdata.userdata)
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isLoggedin, setIsLoggedin] = useState(false)
    const [bookmarkLoading, setBookmarkLoading] = useState({ loadingId: null });
    useEffect(() => {

        GetPopularClasses().then((result) => {
            if (result.status) {
                setData(result.data)
                setLoading(false)
            }
        })
        if (userData) {

            setIsLoggedin(true)
        }
        else {
            setIsLoggedin(false)
        }
    }, [])
    const GotoChai = () => {
        navigate('/chai-club')
    }

    return (
        <section id='popular-section' className='bg-primaryDark text-whiteGrey px-2 xs:px-5 py-8 lg:py-[60px]'>
            <div className="2xl:max-w-2xl xl:max-w-xl lg:max-w-lg md:max-w-md sm:max-w-sm mx-auto">
                <h2 className='text-2xl lg:text-[40px] font-extrabold leading-[normal] text-center'>
                    Popular
                </h2>
                <div className='text-sm font-normal leading-[25.5px] text-center pt-3 lg:text-lg lg:leading-[28px] lg:font-semibold max-w-[670px] mx-auto'>
                    A comprehensive audio and video archive featuring individual lectures, short series, and elaborately detailed series
                </div>
                <div className='py-4 sm:py-8 space-y-3 sm:space-y-4'>

                    {
                        loading ?
                            <div className='py-4 sm:py-8 space-y-3 sm:space-y-4'>
                                <div><Skeleton height={80} /></div>
                                <div><Skeleton height={80} /></div>
                                <div><Skeleton height={80} /></div>
                            </div>
                            :
                            data?.slice(0, 3).map((obj) => (
                                <DataItem
                                    popularClasses={true}
                                    classes={true} 
                                    key={obj.id}
                                    dataObj={obj}
                                    data={data} 
                                    setData={setData} 
                                    bookmarkLoading={bookmarkLoading} 
                                    setBookmarkLoading={setBookmarkLoading} 
                                    isLoggedin={isLoggedin} 
                                />
                            ))
                    }

                </div>
                <button
                    type="button"
                    onClick={GotoChai}
                    className="flex gap-x-1 h-10 mx-auto mt-2 lg:h-12 items-center justify-center rounded-3xl bg-primaryBlue hover:bg-opacity-[0.9] focus:bg-primaryBlue px-8 py-1.5 text-sm md:text-base font-normal leading-7 text-whiteGrey shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
                >
                    Join our Chai Club
                    <span aria-hidden="true" className='text-[13px]'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M17.92 11.62C17.8724 11.4973 17.801 11.3851 17.71 11.29L12.71 6.29C12.6168 6.19676 12.5061 6.1228 12.3842 6.07234C12.2624 6.02188 12.1319 5.99591 12 5.99591C11.7337 5.99591 11.4783 6.1017 11.29 6.29C11.1968 6.38324 11.1228 6.49393 11.0723 6.61575C11.0219 6.73758 10.9959 6.86814 10.9959 7C10.9959 7.2663 11.1017 7.5217 11.29 7.71L14.59 11H7C6.73478 11 6.48043 11.1054 6.29289 11.2929C6.10536 11.4804 6 11.7348 6 12C6 12.2652 6.10536 12.5196 6.29289 12.7071C6.48043 12.8946 6.73478 13 7 13H14.59L11.29 16.29C11.1963 16.383 11.1219 16.4936 11.0711 16.6154C11.0203 16.7373 10.9942 16.868 10.9942 17C10.9942 17.132 11.0203 17.2627 11.0711 17.3846C11.1219 17.5064 11.1963 17.617 11.29 17.71C11.383 17.8037 11.4936 17.8781 11.6154 17.9289C11.7373 17.9797 11.868 18.0058 12 18.0058C12.132 18.0058 12.2627 17.9797 12.3846 17.9289C12.5064 17.8781 12.617 17.8037 12.71 17.71L17.71 12.71C17.801 12.6149 17.8724 12.5028 17.92 12.38C18.02 12.1365 18.02 11.8635 17.92 11.62Z" fill="#F4FBF7" />
                        </svg>
                    </span>
                </button>
            </div>
        </section>
    )
}

export default Popular